var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamsEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.606,
    height: 19.605,
    viewBox: "0 0 19.606 19.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8436",
    "data-name": "Rectangle 8436",
    width: 19.606,
    height: 19.605,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16107",
    "data-name": "Group 16107",
    transform: "translate(-0.816 -0.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16106",
    "data-name": "Group 16106",
    transform: "translate(0.816 0.816)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5877",
    "data-name": "Path 5877",
    d: "M19.268,7.612v7.459A4.544,4.544,0,0,1,14.735,19.6H4.533A4.544,4.544,0,0,1,0,15.072V4.87A4.544,4.544,0,0,1,4.533.337h7.481V2.431H4.533a2.45,2.45,0,0,0-2.44,2.44v10.2a2.45,2.45,0,0,0,2.44,2.44h10.2a2.45,2.45,0,0,0,2.44-2.44V7.613Zm-7.9,3.55L19,3.528A2.068,2.068,0,0,0,16.076.6L8.145,8.533l-.069.153L7.634,11.7a.237.237,0,0,0,.27.266l3.033-.445c.126-.019.3-.234.429-.363Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsEdit);
export default __webpack_public_path__ + "static/media/teams_edit.c3eb20a9161b519f38eec1afa0ed7f37.svg";
export { ForwardRef as ReactComponent };